var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"push-list"},_vm._l((_vm.$content.push),function(push,index){return _c('PushCard',{key:index,staticClass:"push-card",attrs:{"push":push}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }